module.exports = __webpack_public_path__ + "static/img/btn_shibai_nor@2x.42e7199.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/IdentitAuthentication/images/btn_shibai_nor@2x.png
// module id = Kkqt
// module chunks = 1